export const DASHBOARD_LOJAS_EXCLUIDAS = ['106', '112', '095'];

export const dashboardLojaOptions = [
    {
        "value":  "001",
        "label":  "001 - HAVAN S.A. MTZ LOJA 1",
        "cnpj":  "79379491000183"
    },
    {
        "value":  "003",
        "label":  "003 - HAVAN S.A. BRG LOJA 3",
        "cnpj":  "79379491000507"
    },
    {
        "value":  "004",
        "label":  "004 - Havan S.A. PRL LOJA 4",
        "cnpj":  "79379491000779"
    },
    {
        "value":  "005",
        "label":  "005 - Havan S.A. FLN LOJA 5",
        "cnpj":  "79379491000264"
    },
    {
        "value":  "006",
        "label":  "006 - HAVAN S.A. JVE LOJA 6",
        "cnpj":  "79379491000930"
    },
    {
        "value":  "007",
        "label":  "007 - Havan S.A. CRS LOJA 7",
        "cnpj":  "79379491001074"
    },
    {
        "value":  "008",
        "label":  "008 - Havan S.A. BNU LOJA 8",
        "cnpj":  "79379491001155"
    },
    {
        "value":  "009",
        "label":  "009 - HAVAN S.A. BAL LOJA 9",
        "cnpj":  "79379491001236"
    },
    {
        "value":  "010",
        "label":  "010 - HAVAN LOJAS DE DEPARTAMENTO LTDA (BRUSQUE)",
        "cnpj":  "79379491000850"
    },
    {
        "value":  "012",
        "label":  "012 - Havan S.A. CHA LOJA 12",
        "cnpj":  "79379491001406"
    },
    {
        "value":  "013",
        "label":  "013 - Havan S.A. JRS LOJA 13",
        "cnpj":  "79379491001589"
    },
    {
        "value":  "014",
        "label":  "014 - Havan S.A. CST LOJA 14",
        "cnpj":  "79379491001660"
    },
    {
        "value":  "015",
        "label":  "015 - Havan S.A. POR LOJA 15",
        "cnpj":  "79379491001740"
    },
    {
        "value":  "016",
        "label":  "016 - HAVAN S.A. LAG LOJA 16",
        "cnpj":  "79379491001821"
    },
    {
        "value":  "017",
        "label":  "017 - Havan S.A. CCV LOJA 17",
        "cnpj":  "79379491000345"
    },
    {
        "value":  "018",
        "label":  "018 - HAVAN S.A. TUB LOJA 18",
        "cnpj":  "79379491001902"
    },
    {
        "value":  "019",
        "label":  "019 - HAVAN S.A.",
        "cnpj":  "79379491002046"
    },
    {
        "value":  "020",
        "label":  "020 - Havan S.A. SJP LOJA 20",
        "cnpj":  "79379491002127"
    },
    {
        "value":  "021",
        "label":  "021 - Havan S.A. PAL LOJA 21",
        "cnpj":  "79379491002208"
    },
    {
        "value":  "022",
        "label":  "022 - HAVAN S.A. (CDH BARRA VELHA)",
        "cnpj":  "79379491002399"
    },
    {
        "value":  "023",
        "label":  "023 - Havan S.A. FLS LOJA 23",
        "cnpj":  "79379491002470"
    },
    {
        "value":  "024",
        "label":  "024 - HAVAN S.A. MRG LOJA 24",
        "cnpj":  "79379491002550"
    },
    {
        "value":  "025",
        "label":  "025 - Havan S.A. PRH LOJA 25",
        "cnpj":  "79379491002631"
    },
    {
        "value":  "026",
        "label":  "026 - Havan S.A. RBC LOJA 26",
        "cnpj":  "79379491002712"
    },
    {
        "value":  "027",
        "label":  "027 - Havan S.A. SJO LOJA 27",
        "cnpj":  "79379491002801"
    },
    {
        "value":  "028",
        "label":  "028 - Havan S.A. NOR LOJA 28",
        "cnpj":  "79379491002984"
    },
    {
        "value":  "029",
        "label":  "029 - HAVAN S.A. LON LOJA 29",
        "cnpj":  "79379491003018"
    },
    {
        "value":  "030",
        "label":  "030 - Havan S.A. EUR LOJA 30",
        "cnpj":  "79379491003107"
    },
    {
        "value":  "031",
        "label":  "031 - Havan S.A. PAT LOJA 31",
        "cnpj":  "79379491003280"
    },
    {
        "value":  "032",
        "label":  "032 - Havan S.A. BOM LOJA 32",
        "cnpj":  "79379491003794"
    },
    {
        "value":  "033",
        "label":  "033 - Havan S.A. TOL LOJA 33",
        "cnpj":  "79379491003522"
    },
    {
        "value":  "034",
        "label":  "034 - Havan S.A. AVE LOJA 34",
        "cnpj":  "79379491003603"
    },
    {
        "value":  "035",
        "label":  "035 - HAVAN S.A. ITA LOJA 35",
        "cnpj":  "79379491003360"
    },
    {
        "value":  "036",
        "label":  "036 - Havan S.A. XAX LOJA 36",
        "cnpj":  "79379491003875"
    },
    {
        "value":  "037",
        "label":  "037 - Havan S.A. PIN LOJA 37",
        "cnpj":  "79379491003441"
    },
    {
        "value":  "038",
        "label":  "038 - Havan S.A. PAR LOJA 38",
        "cnpj":  "79379491003956"
    },
    {
        "value":  "039",
        "label":  "039 - Havan S.A. PRU LOJA 39",
        "cnpj":  "79379491004090"
    },
    {
        "value":  "041",
        "label":  "041 - Havan S.A. PTG LOJA 41",
        "cnpj":  "79379491004170"
    },
    {
        "value":  "042",
        "label":  "042 - Havan S.A. GTS LOJA 42",
        "cnpj":  "79379491004251"
    },
    {
        "value":  "043",
        "label":  "043 - Havan S.A. ARC LOJA 43",
        "cnpj":  "79379491004332"
    },
    {
        "value":  "044",
        "label":  "044 - Havan S.A. CLG LOJA 44",
        "cnpj":  "79379491004413"
    },
    {
        "value":  "045",
        "label":  "045 - Havan S.A. ARA LOJA 45",
        "cnpj":  "79379491004502"
    },
    {
        "value":  "046",
        "label":  "046 - Havan S.A. SRP LOJA 46",
        "cnpj":  "79379491004766"
    },
    {
        "value":  "047",
        "label":  "047 - Havan S.A. VZG LOJA 47",
        "cnpj":  "79379491005061"
    },
    {
        "value":  "048",
        "label":  "048 - Havan S.A. LIM LOJA 48",
        "cnpj":  "79379491005223"
    },
    {
        "value":  "049",
        "label":  "049 - Havan S.A. ITP LOJA 49",
        "cnpj":  "79379491004685"
    },
    {
        "value":  "050",
        "label":  "050 - Havan S.A. ECV LOJA 50",
        "cnpj":  "79379491005576"
    },
    {
        "value":  "051",
        "label":  "051 - Havan S.A. GUA LOJA 51",
        "cnpj":  "79379491004847"
    },
    {
        "value":  "052",
        "label":  "052 - Havan S.A. LCE LOJA 52",
        "cnpj":  "79379491004928"
    },
    {
        "value":  "053",
        "label":  "053 - Havan S.A. SCA LOJA 53",
        "cnpj":  "79379491005304"
    },
    {
        "value":  "054",
        "label":  "054 - Havan S.A. RDS LOJA 54",
        "cnpj":  "79379491005142"
    },
    {
        "value":  "055",
        "label":  "055 - Havan S.A. DOU LOJA 55",
        "cnpj":  "79379491005495"
    },
    {
        "value":  "056",
        "label":  "056 - Havan S.A. RPR LOJA 56",
        "cnpj":  "79379491005657"
    },
    {
        "value":  "057",
        "label":  "057 - HAVAN S.A. SIN LOJA 57",
        "cnpj":  "79379491005738"
    },
    {
        "value":  "058",
        "label":  "058 - Havan S.A. CUI LOJA 58",
        "cnpj":  "79379491005819"
    },
    {
        "value":  "059",
        "label":  "059 - Havan S.A. RON LOJA 59",
        "cnpj":  "79379491005908"
    },
    {
        "value":  "060",
        "label":  "060 - HAVAN S.A.",
        "cnpj":  "79379491006033"
    },
    {
        "value":  "061",
        "label":  "061 - Havan S.A. BAU LOJA 61",
        "cnpj":  "79379491006203"
    },
    {
        "value":  "062",
        "label":  "062 - Havan S.A. SBO LOJA 62",
        "cnpj":  "79379491006386"
    },
    {
        "value":  "063",
        "label":  "063 - HAVAN S.A.",
        "cnpj":  "79379491006114"
    },
    {
        "value":  "064",
        "label":  "064 - Havan S.A. CRI LOJA 64",
        "cnpj":  "79379491006467"
    },
    {
        "value":  "065",
        "label":  "065 - Havan S.A. PIR LOJA 65",
        "cnpj":  "79379491006548"
    },
    {
        "value":  "066",
        "label":  "066 - HAVAN S.A. MDC LOJA 66",
        "cnpj":  "79379491006629"
    },
    {
        "value":  "067",
        "label":  "067 - Havan S.A. SJC LOJA 67",
        "cnpj":  "79379491006700"
    },
    {
        "value":  "068",
        "label":  "068 - Havan S.A. JUN LOJA 68",
        "cnpj":  "79379491006890"
    },
    {
        "value":  "069",
        "label":  "069 - HAVAN S.A. FRA LOJA 69",
        "cnpj":  "79379491006971"
    },
    {
        "value":  "070",
        "label":  "070 - Havan S.A. SOR LOJA 70",
        "cnpj":  "79379491007005"
    },
    {
        "value":  "071",
        "label":  "071 - Havan S.A. BCB LOJA 71",
        "cnpj":  "79379491009300"
    },
    {
        "value":  "072",
        "label":  "072 - HAVAN S.A.",
        "cnpj":  "79379491007196"
    },
    {
        "value":  "073",
        "label":  "073 - HAVAN S.A. CAM LOJA 73",
        "cnpj":  "79379491012602"
    },
    {
        "value":  "074",
        "label":  "074 - Havan S.A. VAL LOJA 74",
        "cnpj":  "79379491007781"
    },
    {
        "value":  "075",
        "label":  "075 - Havan S.A. JRG LOJA 75",
        "cnpj":  "79379491007277"
    },
    {
        "value":  "076",
        "label":  "076 - Havan S.A. UBE LOJA 76",
        "cnpj":  "79379491007609"
    },
    {
        "value":  "077",
        "label":  "077 - HAVAN S.A.",
        "cnpj":  "79379491007943"
    },
    {
        "value":  "078",
        "label":  "078 - HAVAN S.A. GOI LOJA 78",
        "cnpj":  "79379491019364"
    },
    {
        "value":  "079",
        "label":  "079 - Havan S.A. PLM LOJA 79",
        "cnpj":  "79379491007439"
    },
    {
        "value":  "080",
        "label":  "080 - Havan S.A. PVH LOJA 80",
        "cnpj":  "79379491007510"
    },
    {
        "value":  "081",
        "label":  "081 - Havan S.A. HOR LOJA 81",
        "cnpj":  "79379491008591"
    },
    {
        "value":  "082",
        "label":  "082 - Havan S.A. PPB LOJA 82",
        "cnpj":  "79379491008168"
    },
    {
        "value":  "083",
        "label":  "083 - HAVAN S.A. MRB LOJA 83",
        "cnpj":  "79379491008087"
    },
    {
        "value":  "084",
        "label":  "084 - Havan S.A. CGD LOJA 84",
        "cnpj":  "79379491008834"
    },
    {
        "value":  "085",
        "label":  "085 - Havan S.A. BDG LOJA 85",
        "cnpj":  "79379491010146"
    },
    {
        "value":  "086",
        "label":  "086 - Havan S.A. CUB LOJA 86",
        "cnpj":  "79379491015610"
    },
    {
        "value":  "087",
        "label":  "087 - Havan S.A. TGS LOJA 87",
        "cnpj":  "79379491008320"
    },
    {
        "value":  "088",
        "label":  "088 - Havan S.A. LOR LOJA 88",
        "cnpj":  "79379491008672"
    },
    {
        "value":  "089",
        "label":  "089 - Havan S.A. JUI LOJA 89",
        "cnpj":  "79379491009997"
    },
    {
        "value":  "090",
        "label":  "090 - Havan S.A. BAR LOJA 90",
        "cnpj":  "79379491008400"
    },
    {
        "value":  "091",
        "label":  "091 - Havan S.A. ARP LOJA 91",
        "cnpj":  "79379491009130"
    },
    {
        "value":  "092",
        "label":  "092 - Havan S.A. SPA LOJA 92",
        "cnpj":  "79379491009059"
    },
    {
        "value":  "093",
        "label":  "093 - Havan S.A. TLA LOJA 93",
        "cnpj":  "79379491008915"
    },
    {
        "value":  "094",
        "label":  "094 - Havan S.A. POU LOJA 94",
        "cnpj":  "79379491008753"
    },
    {
        "value":  "095",
        "label":  "095 - HAVAN S.A.",
        "cnpj":  "79379491007358"
    },
    {
        "value":  "096",
        "label":  "096 - Havan S.A. UMU LOJA 96",
        "cnpj":  "79379491009482"
    },
    {
        "value":  "097",
        "label":  "097 - Havan S.A. ARG LOJA 97",
        "cnpj":  "79379491009210"
    },
    {
        "value":  "098",
        "label":  "098 - HAVAN S.A. UBE LOJA 98",
        "cnpj":  "79379491009725"
    },
    {
        "value":  "099",
        "label":  "099 - Havan S.A. LRV LOJA 99",
        "cnpj":  "79379491009644"
    },
    {
        "value":  "101",
        "label":  "101 - Havan S.A. PET LOJA 101",
        "cnpj":  "79379491009563"
    },
    {
        "value":  "102",
        "label":  "102 - Havan S.A. PBA LOJA 102",
        "cnpj":  "79379491009806"
    },
    {
        "value":  "103",
        "label":  "103 - HAVAN S.A. PRA LOJA 103",
        "cnpj":  "79379491010650"
    },
    {
        "value":  "104",
        "label":  "104 - Havan S.A. VIL LOJA 104",
        "cnpj":  "79379491010227"
    },
    {
        "value":  "105",
        "label":  "105 - Havan S.A. LIN LOJA 105",
        "cnpj":  "79379491010308"
    },
    {
        "value":  "106",
        "label":  "106 - Havan S.A. CCG LOJA 106",
        "cnpj":  "79379491008249"
    },
    {
        "value":  "107",
        "label":  "107 - Havan S.A. CAC LOJA 107",
        "cnpj":  "79379491010499"
    },
    {
        "value":  "108",
        "label":  "108 - Havan S.A. ACR LOJA 108",
        "cnpj":  "79379491011037"
    },
    {
        "value":  "109",
        "label":  "109 - Havan S.A. VCT LOJA 109",
        "cnpj":  "79379491012190"
    },
    {
        "value":  "110",
        "label":  "110 - Havan S.A. ITJ LOJA 110",
        "cnpj":  "79379491014648"
    },
    {
        "value":  "111",
        "label":  "111 - HAVAN S.A.",
        "cnpj":  "79379491011380"
    },
    {
        "value":  "112",
        "label":  "112 - Havan S.A. CDL LOJA 112",
        "cnpj":  "79379491010570"
    },
    {
        "value":  "113",
        "label":  "113 - HAVAN S.A. IND LOJA 113",
        "cnpj":  "79379491010065"
    },
    {
        "value":  "114",
        "label":  "114 - Havan S.A. FZI LOJA 114",
        "cnpj":  "79379491010731"
    },
    {
        "value":  "115",
        "label":  "115 - Havan S.A. ITQ LOJA 115",
        "cnpj":  "79379491010901"
    },
    {
        "value":  "116",
        "label":  "116 - Havan S.A. BPT LOJA 116",
        "cnpj":  "79379491010812"
    },
    {
        "value":  "117",
        "label":  "117 - Havan S.A. PBL LOJA 117",
        "cnpj":  "79379491011207"
    },
    {
        "value":  "118",
        "label":  "118 - Havan S.A. VRG LOJA 118",
        "cnpj":  "79379491011460"
    },
    {
        "value":  "119",
        "label":  "119 - HAVAN S.A. TAU LOJA 119",
        "cnpj":  "79379491011703"
    },
    {
        "value":  "120",
        "label":  "120 - Havan S.A. LGS LOJA 120",
        "cnpj":  "79379491011118"
    },
    {
        "value":  "121",
        "label":  "121 - Havan S.A. JOA LOJA 121",
        "cnpj":  "79379491011541"
    },
    {
        "value":  "122",
        "label":  "122 - Havan S.A. ISH LOJA 122",
        "cnpj":  "79379491011622"
    },
    {
        "value":  "123",
        "label":  "123 - HAVAN  S.A NVT LOJA 123",
        "cnpj":  "79379491011894"
    },
    {
        "value":  "125",
        "label":  "125 - Havan S.A. VID LOJA 125",
        "cnpj":  "79379491011975"
    },
    {
        "value":  "127",
        "label":  "127 - Havan S.A. BEN LOJA 127",
        "cnpj":  "79379491012351"
    },
    {
        "value":  "128",
        "label":  "128 - Havan S.A. SAJ LOJA 128",
        "cnpj":  "79379491012270"
    },
    {
        "value":  "129",
        "label":  "129 - Havan S.A. BIG LOJA 129",
        "cnpj":  "79379491012432"
    },
    {
        "value":  "130",
        "label":  "130 - Havan S.A. VLS LOJA 130",
        "cnpj":  "79379491012947"
    },
    {
        "value":  "131",
        "label":  "131 - Havan S.A. ARQ LOJA 131",
        "cnpj":  "79379491012866"
    },
    {
        "value":  "132",
        "label":  "132 - Havan S.A. PRN LOJA 132",
        "cnpj":  "79379491013323"
    },
    {
        "value":  "134",
        "label":  "134 - HAVAN S.A.",
        "cnpj":  "79379491013080"
    },
    {
        "value":  "135",
        "label":  "135 - Havan S.A. VRE LOJA 135",
        "cnpj":  "79379491012785"
    },
    {
        "value":  "136",
        "label":  "136 - Havan S.A. BRA LOJA 136",
        "cnpj":  "79379491013161"
    },
    {
        "value":  "137",
        "label":  "137 - Havan S.A. PLH LOJA 137",
        "cnpj":  "79379491015539"
    },
    {
        "value":  "138",
        "label":  "138 - HAVAN S.A. CXA LOJA 138",
        "cnpj":  "79379491013242"
    },
    {
        "value":  "139",
        "label":  "139 - Havan S.A. MOM LOJA 139",
        "cnpj":  "79379491013676"
    },
    {
        "value":  "140",
        "label":  "140 - Havan S.A. VTP LOJA 140",
        "cnpj":  "79379491013404"
    },
    {
        "value":  "141",
        "label":  "141 - HAVAN S.A. IDT LOJA 141",
        "cnpj":  "79379491013595"
    },
    {
        "value":  "142",
        "label":  "142 - Havan S.A. CMO LOJA 142",
        "cnpj":  "79379491014052"
    },
    {
        "value":  "143",
        "label":  "143 - Havan S.A. MRL LOJA 143",
        "cnpj":  "79379491013919"
    },
    {
        "value":  "144",
        "label":  "144 - Havan S.A. SFS LOJA 144",
        "cnpj":  "79379491013757"
    },
    {
        "value":  "145",
        "label":  "145 - HAVAN S.A. FRG LOJA 145",
        "cnpj":  "79379491013838"
    },
    {
        "value":  "146",
        "label":  "146 - Havan S.A. STZ LOJA 146",
        "cnpj":  "79379491015296"
    },
    {
        "value":  "147",
        "label":  "147 - HAVAN S.A. JAC LOJA 147",
        "cnpj":  "79379491014729"
    },
    {
        "value":  "148",
        "label":  "148 - HAVAN S.A. PEL LOJA 148",
        "cnpj":  "79379491014567"
    },
    {
        "value":  "149",
        "label":  "149 - Havan S.A. RGD LOJA 149",
        "cnpj":  "79379491014214"
    },
    {
        "value":  "150",
        "label":  "150 - Havan S.A. SCS LOJA 150",
        "cnpj":  "79379491014303"
    },
    {
        "value":  "151",
        "label":  "151 - HAVAN S.A",
        "cnpj":  "79379491014486"
    },
    {
        "value":  "152",
        "label":  "152 - HAVAN S.A. STM LOJA 152",
        "cnpj":  "79379491014133"
    },
    {
        "value":  "153",
        "label":  "153 - HAVAN S.A. SRS LOJA 153",
        "cnpj":  "79379491015024"
    },
    {
        "value":  "154",
        "label":  "154 - HAVAN S.A. BEL LOJA 154",
        "cnpj":  "79379491016691"
    },
    {
        "value":  "155",
        "label":  "155 - HAVAN S.A. CSV LOJA 155",
        "cnpj":  "79379491012009"
    },
    {
        "value":  "156",
        "label":  "156 - HAVAN S.A. AND LOJA 156",
        "cnpj":  "79379491016187"
    },
    {
        "value":  "157",
        "label":  "157 - Havan S.A. ITG LOJA 157",
        "cnpj":  "79379491014800"
    },
    {
        "value":  "158",
        "label":  "158 - Havan S.A. IJU LOJA 158",
        "cnpj":  "79379491014990"
    },
    {
        "value":  "159",
        "label":  "159 - HAVAN S.A. CDC LOJA 159",
        "cnpj":  "79379491016772"
    },
    {
        "value":  "161",
        "label":  "161 - Havan S.A. BTC LOJA 161",
        "cnpj":  "79379491015105"
    },
    {
        "value":  "162",
        "label":  "162 - Havan S.A. CSP LOJA 162",
        "cnpj":  "79379491015377"
    },
    {
        "value":  "163",
        "label":  "163 - HAVAN S.A. RES LOJA 163",
        "cnpj":  "79379491017663"
    },
    {
        "value":  "164",
        "label":  "164 - HAVAN S.A. STC LOJA 164",
        "cnpj":  "79379491018473"
    },
    {
        "value":  "165",
        "label":  "165 - HAVAN S.A. CAN LOJA 165",
        "cnpj":  "79379491018120"
    },
    {
        "value":  "166",
        "label":  "166 - HAVAN S.A. CTB LOJA 166",
        "cnpj":  "79379491016268"
    },
    {
        "value":  "167",
        "label":  "167 - Havan S.A. GRA LOJA 167",
        "cnpj":  "79379491015962"
    },
    {
        "value":  "168",
        "label":  "168 - HAVAN S.A. SUM LOJA 168",
        "cnpj":  "79379491015458"
    },
    {
        "value":  "169",
        "label":  "169 - HAVAN S.A. PIO LOJA 169",
        "cnpj":  "79379491016934"
    },
    {
        "value":  "170",
        "label":  "170 - Havan S.A. TSN LOJA 170",
        "cnpj":  "79379491016349"
    },
    {
        "value":  "171",
        "label":  "171 - HAVAN S.A. PVO LOJA 171",
        "cnpj":  "79379491017744"
    },
    {
        "value":  "172",
        "label":  "172 - HAVAN S.A. MCL LOJA 172",
        "cnpj":  "79379491017825"
    },
    {
        "value":  "173",
        "label":  "173 - HAVAN S.A.",
        "cnpj":  "79379491016853"
    },
    {
        "value":  "174",
        "label":  "174 - Havan S.A. ERE LOJA 174",
        "cnpj":  "79379491015709"
    },
    {
        "value":  "175",
        "label":  "175 - HAVAN S.A. MVN LOJA 175",
        "cnpj":  "79379491016420"
    },
    {
        "value":  "176",
        "label":  "176 - HAVAN SAO JOSE DOS PINHAIS 176",
        "cnpj":  "79379491021180"
    },
    {
        "value":  "178",
        "label":  "178 - Havan S.A. LJD LOJA 178",
        "cnpj":  "79379491016004"
    },
    {
        "value":  "179",
        "label":  "179 - HAVAN S.A. OSA LOJA 179",
        "cnpj":  "79379491017582"
    },
    {
        "value":  "181",
        "label":  "181 - HAVAN S.A. TLD LOJA 181",
        "cnpj":  "79379491019445"
    },
    {
        "value":  "182",
        "label":  "182 - HAVAN S.A. ARJ LOJA 182",
        "cnpj":  "79379491017078"
    },
    {
        "value":  "183",
        "label":  "183 - HAVAN S.A. NAT LOJA 183",
        "cnpj":  "79379491017159"
    },
    {
        "value":  "184",
        "label":  "184 - HAVAN S.A.",
        "cnpj":  "79379491017230"
    },
    {
        "value":  "185",
        "label":  "185 - HAVAN S.A. PML LOJA 185",
        "cnpj":  "79379491018392"
    },
    {
        "value":  "186",
        "label":  "186 - HAVAN S.A. ALF LOJA 186",
        "cnpj":  "79379491019011"
    },
    {
        "value":  "187",
        "label":  "187 - HAVAN S.A. SLS LOJA 187",
        "cnpj":  "79379491017310"
    },
    {
        "value":  "188",
        "label":  "188 - HAVAN S.A. PAA LOJA 188",
        "cnpj":  "79379491018040"
    },
    {
        "value":  "189",
        "label":  "189 - HAVAN S.A. SBC LOJA 189",
        "cnpj":  "79379491017400"
    },
    {
        "value":  "191",
        "label":  "191 - HAVAN S.A. TAQ LOJA 191",
        "cnpj":  "79379491020109"
    },
    {
        "value":  "192",
        "label":  "192 - HAVAN S.A. CNS LOJA 192",
        "cnpj":  "79379491019798"
    },
    {
        "value":  "195",
        "label":  "195 - HAVAN GARIBALDI",
        "cnpj":  "79379491020028"
    },
    {
        "value":  "196",
        "label":  "196 - HAVAN S.A. MAC LOJA 196",
        "cnpj":  "79379491018201"
    },
    {
        "value":  "198",
        "label":  "198 - HAVAN S.A. MVN LOJA 198",
        "cnpj":  "79379491018554"
    },
    {
        "value":  "199",
        "label":  "199 - HAVAN S.A. NHB LOJA 199",
        "cnpj":  "79379491019283"
    },
    {
        "value":  "201",
        "label":  "201 - HAVAN S.A. TBA LOJA 201",
        "cnpj":  "79379491019526"
    },
    {
        "value":  "203",
        "label":  "203 - HAVAN S.A. BEC LOJA 203",
        "cnpj":  "79379491020290"
    },
    {
        "value":  "204",
        "label":  "204 - HAVAN S.A. JIP LOJA 204",
        "cnpj":  "79379491018716"
    },
    {
        "value":  "205",
        "label":  "205 - HAVAN S.A. JOB LOJA 205",
        "cnpj":  "79379491001317"
    },
    {
        "value":  "207",
        "label":  "207 - HAVAN S.A. FBE LOJA 207",
        "cnpj":  "79379491018805"
    },
    {
        "value":  "208",
        "label":  "208 - HAVAN S.A. BAG LOJA 208",
        "cnpj":  "79379491018635"
    },
    {
        "value":  "209",
        "label":  "209 - HAVAN S.A. SRO LOJA 209",
        "cnpj":  "79379491018988"
    },
    {
        "value":  "210",
        "label":  "210 - HAVAN FORTALEZA 210",
        "cnpj":  "79379491020885"
    },
    {
        "value":  "212",
        "label":  "212 - HAVAN S.A. CON LOJA 212",
        "cnpj":  "79379491017906"
    },
    {
        "value":  "214",
        "label":  "214 - HAVAN S.A. PAN LOJA 214",
        "cnpj":  "79379491019879"
    },
    {
        "value":  "216",
        "label":  "216 - HAVAN S.A. URU LOJA 216",
        "cnpj":  "79379491019607"
    },
    {
        "value":  "217",
        "label":  "217 - HAVAN S.A. MNG LOJA 217",
        "cnpj":  "79379491019950"
    },
    {
        "value":  "218",
        "label":  "218 - HAVAN S.A. ARI LOJA 218",
        "cnpj":  "79379491020451"
    },
    {
        "value":  "220",
        "label":  "220 - HAVAN S.A",
        "cnpj":  "79379491020532"
    },
    {
        "value":  "221",
        "label":  "221 - HAVAN S.A. BOV LOJA 221",
        "cnpj":  "79379491020613"
    },
    {
        "value":  "222",
        "label":  "222 - HAVAN VILA VELHA 222",
        "cnpj":  "79379491020702"
    },
    {
        "value":  "223",
        "label":  "223 - HAVAN S.A. LNA LOJA 223",
        "cnpj":  "79379491021008"
    },
    {
        "value":  "225",
        "label":  "225 - HAVAN S.A",
        "cnpj":  "79379491021261"
    },
    {
        "value":  "226",
        "label":  "226 - HAVAN S.A. TRA LOJA 226",
        "cnpj":  "79379491021423"
    },
    {
        "value":  "227",
        "label":  "227 - HAVAN SÃO MIGUEL DO OESTE 227",
        "cnpj":  "79379491021342"
    },
    {
        "value":  "301",
        "label":  "301 - HAVAN S.A. SCZ LOJA 301",
        "cnpj":  "79379491000426"
    }
];
